import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type TenantStatusViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  description_esValue?: { displayId: string; id: string } | null;
  description_es: string;
  description_enValue?: { displayId: string; id: string } | null;
  description_en: string;
  description_ptValue?: { displayId: string; id: string } | null;
  description_pt: string;
  blocksAccessValue?: { displayId: string; id: string } | null;
  blocksAccess: boolean;
};

export const TenantStatusViewForm: React.FC<TenantStatusViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name = "",
      description_es = "",
      description_en = "",
      description_pt = "",
      blocksAccess = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupTenantStatusLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name}
                  label={langStore.TenantStatusNameLabel}
                />
                <ShowMultiLine
                  value={description_es}
                  label={langStore.TenantStatusDescriptionLabel + " (es)"}
                />
                ,
                <ShowMultiLine
                  value={description_en}
                  label={langStore.TenantStatusDescriptionLabel + " (en)"}
                />
                ,
                <ShowMultiLine
                  value={description_pt}
                  label={langStore.TenantStatusDescriptionLabel + " (pt)"}
                />
                <ShowBoolean
                  value={blocksAccess}
                  label={langStore.TenantStatusBlocksAccessLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
